import { render, staticRenderFns } from "./ContactLabels.vue?vue&type=template&id=76512953&"
import script from "./ContactLabels.vue?vue&type=script&lang=js&"
export * from "./ContactLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76512953')) {
      api.createRecord('76512953', component.options)
    } else {
      api.reload('76512953', component.options)
    }
    module.hot.accept("./ContactLabels.vue?vue&type=template&id=76512953&", function () {
      api.rerender('76512953', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/components/ContactLabels.vue"
export default component.exports